"use client";

import type React from "react";
import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  VStack,
  useToast,
} from "@chakra-ui/react";
import type { KnowledgeBaseText } from "../../voice-services/knowledgeBaseService"; // Removed .js extension from import

interface AddTextModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (text: KnowledgeBaseText) => void;
}

export const AddTextModal: React.FC<AddTextModalProps> = ({
  isOpen,
  onClose,
  onSave,
}) => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const toast = useToast();

  const handleSubmit = () => {
    if (!title.trim()) {
      toast({
        title: "Title is required",
        status: "error",
        duration: 3000,
      });
      return;
    }

    if (!content.trim()) {
      toast({
        title: "Content is required",
        status: "error",
        duration: 3000,
      });
      return;
    }

    onSave({ title, text: content });
    setTitle("");
    setContent("");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent bg={"white"}>
        <ModalHeader color={"gray.800"}>Add Text</ModalHeader>
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel color={"gray.700"}>File Name</FormLabel>
              <Input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter file name"
                bg={"white"}
                borderColor={"gray.300"}
                color={"gray.800"}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel color={"gray.700"}>Text Content</FormLabel>
              <Textarea
                sx={{
                  "&::-webkit-scrollbar": {
                    height: "4px",
                  },
                  "&::-webkit-scrollbar-button": {
                    display: "none",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#fff",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#fff",
                    borderRadius: "2px",
                  },
                  scrollbarColor: "rgb(220, 220, 220) white",
                  _hover: {
                    scrollbarColor: "rgb(220, 220, 220) white",
                  },
                }}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Enter text content"
                bg={"white"}
                borderColor={"gray.300"}
                color={"gray.800"}
                minH="200px"
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            color={"gray.700"}
            _hover={{ bg: "gray.100" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            colorScheme="primary"
            bg="primary.800"
            _hover={{ bg: "primary.900" }}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
